/*
  Previous and next arrows on the product photo (tablet and desktop).

  The theme shows one photo at a time with a row of thumbnails under it.
  These arrows step through the same thumbnails, so they respect whichever
  photos are showing for the chosen colour or size. Phones already get the
  theme's own swipe gallery with arrows.
*/
(function () {
  /* Translated wording comes from window.elementalStrings (layout/theme.liquid). */
  function phrase(key, fallback) {
    var strings = window.elementalStrings || {};
    return strings[key] || fallback;
  }

  var CHEVRON =
    '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"/></svg>';

  function setup(gallery) {
    if (gallery.getAttribute('data-elemental-arrows')) return;
    var viewer = gallery.querySelector('slider-component');
    var thumbnails = gallery.querySelector('.thumbnail-list');
    if (!viewer || !thumbnails) return;
    gallery.setAttribute('data-elemental-arrows', 'true');

    function showing() {
      return Array.prototype.filter.call(thumbnails.querySelectorAll('.thumbnail-list__item'), function (item) {
        return item.offsetParent !== null;
      });
    }

    function step(direction) {
      var items = showing();
      if (items.length < 2) return;
      var at = 0;
      items.forEach(function (item, position) {
        if (item.querySelector('button[aria-current="true"]')) at = position;
      });
      var next = items[(at + direction + items.length) % items.length];
      var button = next.querySelector('button');
      if (button) button.click();
    }

    function arrow(direction, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'elemental-gallery-arrow elemental-gallery-arrow--' + (direction < 0 ? 'prev' : 'next');
      button.setAttribute('aria-label', label);
      button.innerHTML = CHEVRON;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(direction);
      });
      return button;
    }

    viewer.classList.add('elemental-gallery-viewer');
    viewer.appendChild(arrow(-1, phrase('previous_photo', 'Previous photo')));
    viewer.appendChild(arrow(1, phrase('next_photo', 'Next photo')));

    // Hide the arrows when only one photo is showing (for example after a
    // colour with a single photo is picked).
    function refresh() {
      gallery.classList.toggle('elemental-gallery--single', showing().length < 2);
    }
    refresh();
    document.addEventListener('change', function () {
      window.setTimeout(refresh, 250);
    });
    window.addEventListener('resize', refresh);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('media-gallery'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
